import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, NgModule, Output } from '@angular/core';
import { WOption, WOptionOrString } from '@wipo/w-angular/shared';

@Component({
  selector: 'w-input-dropdown',
  templateUrl: './w-input-dropdown.component.html',
  host: {
    class: 'b-input-dropdown b-dropdown',
    '[class.b-notice]': '!!text',
    '[class.b-contains-selected]': 'containsSelected()',
  },
  standalone: false
})
export class WInputDropdownComponent {
  @Input() text: string = '';
  @Input() list: WOptionOrString[] = [];
  @Input() activeIndex = 0;
  @Input() selected: WOptionOrString[] = [];

  @Output() wDropdownClick = new EventEmitter<WOption | string>();

  label(item: WOptionOrString) {
    return typeof item === 'string' ? item : item.label;
  }
  isDisabled(item: WOptionOrString) {
    return typeof item !== 'string' ? item?.disabled : false;
  }
  isSelected(item: WOptionOrString) {
    return Array.isArray(this.selected) && this.selected.indexOf(item) > -1;
  }
  containsSelected() {
    return this.selected?.length > 0;
  }
  attr(x: any) {
    return x ? x : undefined;
  }
  getTitle(option: WOptionOrString) {
    if (typeof option !== 'string') {
      // if we use WOption array, we can set title for each option
      return this.attr(option?.tip ?? '');
    } else return option; // if we use string array, we can use string as title
  }
}
@NgModule({
  imports: [CommonModule],
  exports: [WInputDropdownComponent],
  declarations: [WInputDropdownComponent]
})
export class WInputDropdownModule { }
